import { Badge, Stack, Box } from '@mui/material'
import CompassButton from './../../Compass/Common/CompassButton/CompassButton'
import { useNavigate } from 'react-router-dom'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import { useUncheckedActions } from '../../generic/hooks/useUncheckedActions'
import actionBadgeStyle from './ActionBadgeStyle'

const ActionCenterMenu = () => {
  const navigate = useNavigate()
  const { t_ } = useSmartTranslation()
  const uncheckedActions = useUncheckedActions()

  return (
    <Stack
      direction='row'
      justifyContent='space-between'
      alignItems='center'
      spacing={4}
      sx={{
        height: '80%',
        paddingX: '10%'
      }}
    >
      <Box>
        <Badge
          invisible={uncheckedActions <= 0}
          badgeContent={uncheckedActions}
          sx={{
            ...actionBadgeStyle,
            '& .MuiBadge-badge': {
              fontSize: '2rem',
              height: '2rem',
              borderRadius: '2rem',
              transform: uncheckedActions > 0 ? 'translate(0.4rem, -0.4rem)' : null
            }
          }}
        >
          <CompassButton
            label={t_('Pending Actions')}
            width='auto'
            height='auto'
            labelStyle={{ fontSize: '1.8rem' }}
            onClick={() => {
              navigate('/process/action')
            }}
            sx={{ padding: '1.5rem' }}
          />
        </Badge>
      </Box>
      <Box>
        <CompassButton
          label={t_('Send Command')}
          width='auto'
          height='auto'
          labelStyle={{ fontSize: '1.8rem' }}
          onClick={() => {
            navigate('/process/command')
          }}
          sx={{ padding: '1.5rem' }}
        />
      </Box>
      <Box>
        <CompassButton
          label={t_('Pending requests')}
          width='auto'
          height='auto'
          labelStyle={{ fontSize: '1.8rem' }}
          onClick={() => {
            navigate('/process/pendingRequests')
          }}
          sx={{ padding: '1.5rem' }}
        />
      </Box>
    </Stack>
  )
}

export default ActionCenterMenu
